"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const one_1 = require("remax/one");
const one_2 = require("../one");
const classnames_1 = __importDefault(require("classnames"));
const _util_1 = require("../_util");
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('swipe');
const SwipeAction = (props) => {
    const { open, options = [], onTouchStart, onOpened, onClosed, children } = props;
    const [x, setX] = react_1.useState(0);
    const [origin, setOrigin] = react_1.useState(0);
    const [transition, setTransition] = react_1.useState('none');
    const [startX, setStartX] = react_1.useState(0);
    const [actionsWidth, setActionsWidth] = react_1.useState(0);
    const swipeId = react_1.useMemo(() => _util_1.guid(), []);
    const handleActionsWidth = (id) => {
        one_2.createSelectorQuery()
            // @ts-ignore
            .select(`.${prefixCls}-actions-${id}`)
            .boundingClientRect()
            .exec((rect) => {
            var _a;
            const w = Array.isArray(rect) ? (_a = rect === null || rect === void 0 ? void 0 : rect[0]) === null || _a === void 0 ? void 0 : _a.width : rect === null || rect === void 0 ? void 0 : rect.width;
            setActionsWidth(w);
        });
    };
    react_1.useEffect(() => {
        handleActionsWidth(swipeId);
    }, []);
    react_1.useEffect(() => {
        const width = Number(`-${actionsWidth}`);
        setX(open ? width : 0);
        setOrigin(open ? width : 0);
        setTransition('all 0.3s');
    }, [open]);
    const throttleTouchMove = _util_1.throttle((e) => {
        const touch = e.touches[0];
        const currenrX = touch.pageX;
        const diff = currenrX - startX;
        const total = diff + origin;
        if (total >= 0) {
            return;
        }
        setX(total);
    }, 30, { trailing: false });
    const handleTouchStart = (e) => {
        // touch当前行时关闭其他行
        onTouchStart === null || onTouchStart === void 0 ? void 0 : onTouchStart(e);
        const touch = e.touches[0];
        setStartX(touch.pageX);
        setTransition('none');
    };
    const handleTouchMove = (e) => {
        // @ts-ignore
        throttleTouchMove(e);
    };
    const handleTouchEnd = (e) => {
        const width = Number(`-${actionsWidth}`);
        if (x >= 0) {
            return;
        }
        if (x > origin) {
            onClosed === null || onClosed === void 0 ? void 0 : onClosed(e);
            setX(0);
            setOrigin(0);
            setTransition('all 0.3s');
            return;
        }
        let x2 = 0;
        let origin2 = 0;
        if (x <= -30) {
            x2 = width;
            origin2 = width;
            onOpened === null || onOpened === void 0 ? void 0 : onOpened(e);
        }
        if (x > -30) {
            x2 = 0;
            origin2 = 0;
            onClosed === null || onClosed === void 0 ? void 0 : onClosed(e);
        }
        setX(x2);
        setOrigin(origin2);
        setTransition('all 0.3s');
    };
    const handleTouchCancel = () => {
        const width = Number(`-${actionsWidth}`);
        setX(width);
        setOrigin(width);
    };
    const handleTap = (item) => {
        var _a;
        (_a = item === null || item === void 0 ? void 0 : item.onTap) === null || _a === void 0 ? void 0 : _a.call(item, item);
    };
    return (react_1.default.createElement(one_1.View, { className: classnames_1.default(prefixCls, {
            [`${prefixCls}-class`]: true,
        }) },
        react_1.default.createElement(one_1.View, { className: `${prefixCls}-container`, onTouchStart: handleTouchStart, onTouchMove: handleTouchMove, onTouchEnd: handleTouchEnd, onTouchCancel: handleTouchCancel, style: {
                transform: `translate3d(${x}PX, 0, 0)`,
                // left: `${x}PX`,
                transition,
            } },
            children,
            react_1.default.createElement(one_1.View, { className: classnames_1.default({
                    [`${prefixCls}-actions`]: true,
                    [`${prefixCls}-actions-${swipeId}`]: true,
                }) }, options === null || options === void 0 ? void 0 : options.map((item, index) => (react_1.default.createElement(one_1.View, { key: index, className: `${prefixCls}-action`, onTap: () => handleTap(item), style: item === null || item === void 0 ? void 0 : item.style }, item === null || item === void 0 ? void 0 : item.name)))))));
};
exports.default = SwipeAction;
